import { ActionCreatorFactory } from "typescript-fsa";

import { DomainAction } from "./interface";

export function createDomainAction<Params>(createAction: ActionCreatorFactory): DomainAction<Params> {
  return {
    init: createAction("DOMAIN_INIT"),
    reset: createAction("DOMAIN_RESET"),
    error: createAction("DOMAIN_INIT_ERROR"),
    success: createAction("DOMAIN_INIT_SUCCESS"),
  };
}
